<script>
import EventForm from '@events/components/event-form.vue'

export default {
  components: { EventForm },
  props: {
    event: {
      type: Object,
      required: true,
    },
    isLoading: Boolean,
    isLoadingExit: Boolean,
  },
  methods: {
    onSaveClick(payload) {
      this.$emit('save', payload)
    },
    onSaveExitClick(payload) {
      this.$emit('saveExit', payload)
      this.$emit('cancel', payload)
    },
    onCancelClick(payload) {
      this.$emit('cancel', payload)
    },
    onCancelEventClick(payload) {
      this.$emit('cancelEvent', payload)
    },
    onDetachEventClick(payload) {
      this.$emit('detachEvent', payload)
    },
  },
}
</script>

<template>
  <EventForm
    :event="event"
    :is-loading="isLoading"
    :is-loading-exit="isLoadingExit"
    @save="onSaveClick"
    @saveExit="onSaveExitClick"
    @cancel="onCancelClick"
    @cancelEvent="onCancelEventClick"
    @detachEvent="onDetachEventClick"
  />
</template>
